import { GroupInterface, LocationInterface, LocationPageInterface, LocationVarKey, OrgInterface } from "@swivl-mono/types";
import { Spinner } from "@swivl-mono/ui";
import _ from "lodash";
import { FaChevronRight } from "react-icons/fa6";

import { SidebarLink } from "../../../Components/SidebarLink/SidebarLink";
import { useLocationVariables } from "../../../Hooks/useLocationVariables";
import LocationsModel from "../../../Models/Locations/Locations.Model";
import { Member } from "../../../Models/Member/Member.Current";
import "./LocationListItemContent.scss";

interface LocationListItemProps {
  org?: OrgInterface;
  group?: GroupInterface;
  location?: LocationInterface;

  // name: string;
  // subtitle?: string;
  // avatarURL?: string;
  // showAvatar?: boolean;
  // showChevron?: boolean;
  // supressTextHover?: boolean;
}
function LocationListItemContent(props: LocationListItemProps) {
  const { org, group, location } = props;
  const vars = useLocationVariables([LocationVarKey.Name, LocationVarKey.AvatarURL], group?.id, location?.id);

  let name, subtitle, avatarURL, showAvatar, showChevron, supressTextHover;

  if (org) {
    supressTextHover = true;
    name = vars?.[LocationVarKey.Name];
    subtitle = "Organization";
    avatarURL = vars?.[LocationVarKey.AvatarURL];
    showAvatar = true;
    showChevron = true;
  }
  if (group) {
    name = vars?.[LocationVarKey.Name];
    avatarURL = vars?.[LocationVarKey.AvatarURL];
    showAvatar = true;
    showChevron = true;
    supressTextHover = true;
  }
  if (location) {
    name = vars?.[LocationVarKey.Name];
    showChevron = false;
  }

  return (
    <div className={`LocationListItemContent h-full w-full flex flex-row items-center justify-start ${supressTextHover ? "supressTextHover" : ""}`}>
      {showAvatar ? (
        <div className="w-8 h-8 bg-grey avatarSpacer mr-3">
          {avatarURL && <img className="w-8 h-8 object-cover rounded-sm bg-white" src={avatarURL} alt={name + " logo"} />}
        </div>
      ) : (
        <div className="w-8 h-8  blackSpace mr-3" />
      )}
      <div className="flex-1 nameAndSubtitle flex flex-col items-start justify-center">
        <div className="name leading-none">{name}</div>
        {subtitle && <div className="subtitle italic text-xs">{subtitle}</div>}
      </div>
      {showChevron && (
        <div className="chevron">
          <FaChevronRight />
        </div>
      )}
    </div>
  );
}

interface LocationsListComponentProps extends LocationPageInterface {
  searchQuery: string;
}

export function LocationsListComponent(props: LocationsListComponentProps) {
  const searchQuery = props.searchQuery;
  const { groups } = LocationsModel.useState();
  const org: OrgInterface = Member.org!;
  const page = props.page ? props.page : "details";
  const action = props.action ? "/" + props.action : "";
  const subpage = props.subPage ? "/" + props.subPage : "";
  // let pageUrl = props.page ? '/page/' + page : '/page/details' + action;
  // if (props.subPage && page) { pageUrl += '/' + props.subPage; }
  const pageUrl = "/page/" + page + subpage + action;

  let filteredGroups = groups;
  if (searchQuery.length >= 1 && groups) {
    filteredGroups = _.cloneDeep(groups);

    for (let i = 0; i < filteredGroups.length; i++) {
      filteredGroups[i].locations = filteredGroups[i].locations.filter((location) => {
        return location.name.toLowerCase().includes(searchQuery.toLowerCase());
      });
    }
    filteredGroups = filteredGroups.filter((group) => {
      return group.locations.length > 0 || group.name.toLowerCase().includes(searchQuery.toLowerCase());
    });
  }

  return (
    <div>
      {Member.canSeeOrgSettings && <SidebarLink greyBackground={true} boarderButtom={true} to={`/properties${pageUrl}`} excludeMatch={`/group`} height={55}>
        <LocationListItemContent org={org} />
      </SidebarLink>
      }

      {!filteredGroups ? (
        <div className="w-full p-10 flex items-center justify-center">
          {" "}
          <Spinner />
        </div>
      ) : (
        filteredGroups?.map((group) => (
          <div key={"groupgroup_" + group.id}>
            <SidebarLink
              greyBackground={true}
              key={"group_" + group.id}
              to={`/properties/group/${group.id}${pageUrl}`}
              excludeMatch={`/location`}
              height={38}
            >
              <LocationListItemContent group={group} />
            </SidebarLink>
            {group?.locations?.map((location) => (
              <SidebarLink key={group.id + "_loc_" + location.id} to={`/properties/group/${group.id}/location/${location.id}${pageUrl}`} height={38}>
                <LocationListItemContent location={location} />
              </SidebarLink>
            ))}
          </div>
        ))
      )}
    </div>
  );
}
